import React from 'react';
import PageHeader from '../components/PageHeader'
import Preloader from '../components/Preloader'
import Footer from '../components/Footer';


const DigiCenter = () => {

    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <PageHeader />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/kwamenkrumah.jpg')" }}>
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                        <div className="text-center text-white px-4">
                            <h1 className="text-5xl md:text-6xl font-cormorant-upright font-bold">Digital Space</h1>
                            <p className="mt-4 text-sm md:text-sm max-w-3xl mx-auto">digital center for our cherished clients</p>
                        </div>
                    </div>
                </section>
                {/* Content Section */}
                <section className="py-20 px-4">
                    <script src="https://elfsightcdn.com/platform.js" async></script>
                    <div class="elfsight-app-deeb8943-38d9-4472-8025-2b5cdde9222a" data-elfsight-app-lazy></div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default DigiCenter